// Reference: https://stackoverflow.com/questions/63482938/use-custom-component-as-tooltip-in-angular

import { Directive, ElementRef, HostListener, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appHtmlTooltip]'
})
export class HtmlTooltipDirective implements OnChanges {

	@Input('tooltip') tooltipTitle: string;
	// @Input() placement = 'bottom';
	@Input() hideDelay = 500;
	showDelay = 1500;
	easeoutTime = 400;
	tooltip: HTMLElement;
	offset = 10;
	// tooltip place relative to the nativeElement
	private relativeLR: 'left' | 'right';
	private relativeTB: 'top' | 'bottom';

	private showTimeout;
	private hideTimeout;
  
	constructor(
		private el: ElementRef,
		private renderer: Renderer2
	) { }
  
	@HostListener('mouseenter') onMouseEnter() {
		this.showTimeout = setTimeout(() => {
			if (!this.tooltip) {
				this.show();
			}
		}, this.showDelay);
	}
  
	@HostListener('mouseleave') onMouseLeave() {
		this.hide();
	}
  
	show() {
		this.create();
		this.setPosition();
		this.renderer.addClass(this.tooltip, 'ng-tooltip-show');
	}
	
	hide() {
		if (this.showTimeout) {
			clearTimeout(this.showTimeout);
		}
		if (this.tooltip) {
			this.hideTimeout = setTimeout(() => {
				this.renderer.removeClass(this.tooltip, 'ng-tooltip-show');
				this.transitionOpacity();
				setTimeout(() => {
					this.renderer.removeChild(document.body, this.tooltip);
					this.tooltip = null;
				}, this.easeoutTime);
			}, this.hideDelay);
		}
	}
	
	private create() {
		this.tooltip = this.renderer.createElement('div');
		// this.tooltip.innerHTML = this.tooltipTitle;

		const innerDiv = this.renderer.createElement('div');
		this.renderer.addClass(innerDiv, 'ng-tooltip-inner'); // TODO: style
		this.renderer.appendChild(this.tooltip, innerDiv);
		const innerSpan = this.renderer.createElement('span');
		innerSpan.innerHTML = this.tooltipTitle || '';
		this.renderer.appendChild(innerDiv, innerSpan);
	
		this.renderer.appendChild(document.body, this.tooltip);

		this.renderer.addClass(this.tooltip, 'ng-tooltip');
		// this.renderer.addClass(this.tooltip, `ng-tooltip-${this.placement}`);
		this.transitionOpacity();

		//
		this.tooltip.addEventListener('mouseover', () => {
			if (this.hideTimeout) {
				clearTimeout(this.hideTimeout);
			}
		});
		this.tooltip.addEventListener('mouseleave', () => {
			this.hide();
		});
	}
	
	private setPosition() {
		const hostPos = this.el.nativeElement.getBoundingClientRect();
		const tooltipPos = this.tooltip.getBoundingClientRect();

		const viewPortHeight = window.innerHeight;
		const viewPortWidth = window.innerWidth;
	
		const scrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
	
		this.relativeLR = (hostPos.left + hostPos.width / 2) < viewPortWidth / 2 ? 'right' : 'left';
		this.relativeTB = (hostPos.top + hostPos.height / 2) < viewPortHeight / 2 ? 'bottom' : 'top';

		// Tooltip position
		let top, left;
		if (this.relativeTB === 'top') {
			top = hostPos.top - tooltipPos.height - this.offset;
			// left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
		} else if (this.relativeTB === 'bottom') {
			top = hostPos.bottom + this.offset;
			// left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
		}
		if (this.relativeLR === 'left') {
			// top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
			left = hostPos.left - tooltipPos.width - this.offset;
		}
		if (this.relativeLR === 'right') {
			// top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
			left = hostPos.right + this.offset;
		}
	
		// if (this.placement === 'top') {
		// 	top = hostPos.top - tooltipPos.height - this.offset;
		// 	left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
		// }
		// if (this.placement === 'bottom') {
		// 	top = hostPos.bottom + this.offset;
		// 	left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
		// }
		// if (this.placement === 'left') {
		// 	top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
		// 	left = hostPos.left - tooltipPos.width - this.offset;
		// }
		// if (this.placement === 'right') {
		// 	top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
		// 	left = hostPos.right + this.offset;
		// }
	
		this.renderer.setStyle(this.tooltip, 'top', `${top + scrollPos}px`);
		this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
	}

	private transitionOpacity() {
		this.renderer.setStyle(this.tooltip, '-webkit-transition', `opacity ${this.easeoutTime}ms`);
		this.renderer.setStyle(this.tooltip, '-moz-transition', `opacity ${this.easeoutTime}ms`);
		this.renderer.setStyle(this.tooltip, '-o-transition', `opacity ${this.easeoutTime}ms`);
		this.renderer.setStyle(this.tooltip, 'transition', `opacity ${this.easeoutTime}ms`);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.tooltipTitle) {
			if (this.tooltipTitle) {
				this.renderer.addClass(this.el.nativeElement, 'item-with-tooltip');
			} else {
				this.renderer.removeClass(this.el.nativeElement, 'item-with-tooltip');
			}
		}
	}

}
